module.exports = __webpack_public_path__ + "img/imweb_design_end.aabd17aa.png";